"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class GroupAssociation {
  static thaw(groupAssociationObj) {
    if (groupAssociationObj == null) return null;
    const groupAssociation = new GroupAssociation();
    if (groupAssociationObj.id != null) groupAssociation.setId(groupAssociationObj.id);
    if (groupAssociationObj.token != null) groupAssociation.setToken(groupAssociationObj.token);
    if (groupAssociationObj.roleId != null) groupAssociation.setRoleId(groupAssociationObj.roleId);
    if (groupAssociationObj.personId != null) groupAssociation.setPersonId(groupAssociationObj.personId);
    if (groupAssociationObj.groupId != null) groupAssociation.setGroupId(groupAssociationObj.groupId);
    if (groupAssociationObj.role != null) groupAssociation.setRole(_.GroupRole.thaw(groupAssociationObj.role));
    if (groupAssociationObj.group != null) groupAssociation.setGroup(_.Group.thaw(groupAssociationObj.group));
    if (groupAssociationObj.person != null) groupAssociation.setPerson(_.Person.thaw(groupAssociationObj.person));
    if (groupAssociationObj.isActive != null) groupAssociation.setIsActive(groupAssociationObj.isActive);
    if (groupAssociationObj.invitationStatus != null) groupAssociation.setInvitationStatus(groupAssociationObj.invitationStatus);
    if (groupAssociationObj.createdAt != null) groupAssociation.setCreatedAt(_luxon.DateTime.fromISO(groupAssociationObj.createdAt));
    if (groupAssociationObj.expiresOn != null) groupAssociation.setExpiresOn(_luxon.DateTime.fromISO(groupAssociationObj.expiresOn));
    return groupAssociation;
  }

  static thawList(groupAssociationObjList) {
    if (groupAssociationObjList == null) return [];
    var groupAssociations = [];

    for (var i = 0; i < groupAssociationObjList.length; i++) {
      groupAssociations.push(GroupAssociation.thaw(groupAssociationObjList[i]));
    }

    return groupAssociations;
  }

  static freeze(groupAssociation) {
    if (groupAssociation == null) return null;
    var groupAssociationObj = {};
    if (groupAssociation.getId() != null) groupAssociationObj.id = groupAssociation.getId();
    if (groupAssociation.getToken() != null) groupAssociationObj.token = groupAssociation.getToken();
    if (groupAssociation.getRoleId() != null) groupAssociationObj.roleId = groupAssociation.getRoleId();
    if (groupAssociation.getPersonId() != null) groupAssociationObj.personId = groupAssociation.getPersonId();
    if (groupAssociation.getGroupId() != null) groupAssociationObj.groupId = groupAssociation.getGroupId();
    if (groupAssociation.getRole() != null) groupAssociationObj.role = _.GroupRole.freeze(groupAssociation.getRole());
    if (groupAssociation.getGroup() != null) groupAssociationObj.group = _.Group.freeze(groupAssociation.getGroup());
    if (groupAssociation.getPerson() != null) groupAssociationObj.person = _.Person.freeze(groupAssociation.getPerson());
    if (groupAssociation.getIsActive() != null) groupAssociationObj.isActive = groupAssociation.getIsActive();
    if (groupAssociation.getInvitationStatus() != null) groupAssociationObj.invitationStatus = groupAssociation.getInvitationStatus();
    if (groupAssociation.getCreatedAt() != null) groupAssociationObj.createdAt = groupAssociation.getCreatedAt();
    if (groupAssociation.getExpiresOn() != null) groupAssociationObj.expiresOn = groupAssociation.getExpiresOn();
    return groupAssociationObj;
  }

  static freezeList(groupAssociations) {
    if (groupAssociations == null) return [];
    var groupAssociationObjList = [];

    for (var i = 0; i < groupAssociations.length; i++) {
      groupAssociationObjList.push(GroupAssociation.freeze(groupAssociations[i]));
    }

    return groupAssociationObjList;
  }

  constructor() {
    this.setId(null);
    this.setToken(null);
    this.setRoleId(null);
    this.setPersonId(null);
    this.setGroupId(null);
    this.setRole(null);
    this.setGroup(null);
    this.setPerson(null);
    this.setIsActive(null);
    this.setInvitationStatus(null);
    this.setCreatedAt(null);
    this.setExpiresOn(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setToken(token) {
    this.token = token;
  }

  setRoleId(roleId) {
    this.roleId = roleId;
  }

  setPersonId(personId) {
    this.personId = personId;
  }

  setGroupId(groupId) {
    this.groupId = groupId;
  }

  setRole(role) {
    this.role = role;
  }

  setGroup(group) {
    this.group = group;
  }

  setPerson(person) {
    this.person = person;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setInvitationStatus(invitationStatus) {
    this.invitationStatus = invitationStatus;
  }

  setCreatedAt(createdAt) {
    this.createdAt = createdAt;
  }

  setExpiresOn(expiresOn) {
    this.expiresOn = expiresOn;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getToken() {
    return this.token;
  }

  getRoleId() {
    return this.roleId;
  }

  getPersonId() {
    return this.personId;
  }

  getGroupId() {
    return this.groupId;
  }

  getRole() {
    return this.role;
  }

  getGroup() {
    return this.group;
  }

  getPerson() {
    return this.person;
  }

  getIsActive() {
    return this.isActive;
  }

  getInvitationStatus() {
    return this.invitationStatus;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getExpiresOn() {
    return this.expiresOn;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = GroupAssociation;